"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValueCell = void 0;
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
function KeyValueCell() {
    return function Cell(props) {
        return (react_1.default.createElement(Typography_1.default, null, props.value
            .map((values) => `${values.collectionName}: ${values.collectionPath}`)
            .join(', ')));
    };
}
exports.KeyValueCell = KeyValueCell;
//# sourceMappingURL=key-value-cell.js.map